<template>
    <div class="rang px-0 pt-3 pb-0">

        <v-card class="pa-2 mb-6"
                flat
                tile>

            <!-- page topbar -->
            <v-row align="center">
                <v-col cols="auto">
                    <back-button />
                </v-col>
                <v-col cols="auto">
                    <h2 class="d-flex mb-0 headline font-weight-bold align-baseline">
                        <v-icon class="mr-3">mdi-podium-silver</v-icon>
                        <span v-html="$options.filters.master(`${$vuetify.lang.t('$vuetify.page_rang_detail.title')}`)"></span>
                    </h2>
                </v-col>
                <v-col class="d-flex flex-row justify-end">
                    <v-select class="custom ml-auto mb-0"
                              :value="filterAchievementTab"
                              hide-details
                              filled
                              :items="brands"
                              item-text="name"
                              item-value="id"
                              @change="handleTabUpdate"
                              outlined></v-select>
                </v-col>
            </v-row>
            <!-- /page topbar -->
        </v-card>

        <v-card class="py-6 px-6"
                flat
                tile>
            <v-row>
                <v-col cols="12"
                       md="5"
                       class="py-0">
                    <div class="px-5 pr-md-0">
                        <v-tabs-items @change="handleTabUpdate"
                                      :value="filterAchievementTab"
                                      class="mt-3 mb-2">
                            <v-tab-item v-for="achievement in achievements"
                                        :key="achievement.id"
                                        background-color="transparent">
                                <div>
                                    <div class="d-flex flex-column align-center">
                                        <v-img aspect-ratio="1"
                                               contain
                                               max-width="128px"
                                               width="100%"
                                               class="mb-3 mb-md-8"
                                               :src="achievement.actual_rank.icon"
                                               v-if="achievement.actual_rank.icon"></v-img>
                                        <div class="text-uppercase body-1 d-flex align-center"
                                             :class="{ 'font-weight-bold': achievement.actual_rank.id === 1 }">
                                            <span v-html="$options.filters.master(achievement.actual_rank.name[$vuetify.lang.current]
                                                ? achievement.actual_rank.name[$vuetify.lang.current]
                                                : achievement.actual_rank.name)"></span>

                                            <v-tooltip v-if="(achievement.actual_rank.name === 'Superior Master' || achievement.actual_rank.name === 'Legend Master') && currentYear === requiredYear"
                                                       color="black"
                                                       transition="fade-transition"
                                                       right>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-img v-if="achievement.protection === true"
                                                           class="ml-1"
                                                           max-width="24"
                                                           max-height="24"
                                                           contain
                                                           v-bind="attrs"
                                                           v-on="on"
                                                           src="@/assets/images/masterrank_preview/protection.svg"></v-img>
                                                    <v-img v-else
                                                           class="ml-1"
                                                           max-width="24"
                                                           max-height="24"
                                                           contain
                                                           v-bind="attrs"
                                                           v-on="on"
                                                           src="@/assets/images/masterrank_preview/protection-used.svg"></v-img>
                                                </template>
                                                <span class="bg-success">
                                                    <h3>{{
                                                            $vuetify.lang.t('$vuetify.page_rang_detail.protection_headline')
                                                        }}</h3>
                                                    <p class="mb-0">
                                                        {{
                                                            $vuetify.lang.t('$vuetify.page_rang_detail.protection_desc')
                                                        }}
                                                    </p>
                                                </span>
                                            </v-tooltip>

                                        </div>
                                    </div>
                                </div>
                            </v-tab-item>
                        </v-tabs-items>
                    </div>
                </v-col>

                <v-col cols="12"
                       md="7"
                       class="py-0">
                    <v-tabs-items @change="handleTabUpdate"
                                  :value="filterAchievementTab"
                                  class="mt-3 mb-2">
                        <v-tab-item v-for="achievement in achievements"
                                    :key="achievement.id"
                                    background-color="transparent">
                            <div>
                                <div class="rang__frame mb-5 pb-2">
                                    <h2 class="d-flex mb-4 headline font-weight-bold align-baseline"
                                        v-if="achievement.actual_rank.name === 'Ultimate Master'">
                                        <span v-html="$vuetify.lang.t('$vuetify.page_rang_detail.you_are_a', $options.filters.master(achievement.next_rank.name))"></span>
                                    </h2>
                                    <h2 class="d-flex mb-4 mt-2 headline font-weight-bold align-baseline"
                                        v-else>
                                        <template v-if="(achievement.actual_rank.name === 'Superior Master' || achievement.actual_rank.name === 'Legend Master') && currentYear === requiredYear">
                                            <span v-html="$vuetify.lang.t('$vuetify.page_rang_detail.become_a_in_two_years', $options.filters.master(achievement.next_rank.name))"></span>
                                        </template>
                                        <template v-else>
                                            <span v-html="$vuetify.lang.t('$vuetify.page_rang_detail.become_a', $options.filters.master(achievement.next_rank.name))"></span>
                                        </template>
                                    </h2>

                                    <v-row dense
                                           class="mb-5"
                                           v-if="(achievement.actual_rank.name === 'Superior Master' || achievement.actual_rank.name === 'Legend Master') && currentYear === requiredYear">
                                        <v-col>
                                            2022
                                            <v-img class="hidden-sm-and-up"
                                                   contain
                                                   src="@/assets/images/masterrank_preview/preview-progress.svg"></v-img>
                                            <v-img class="hidden-xs-only"
                                                   contain
                                                   src="@/assets/images/masterrank_preview/preview-progress-xl.svg"></v-img>
                                        </v-col>
                                        <v-col>
                                            2023
                                            <v-img class="hidden-sm-and-up"
                                                   contain
                                                   src="@/assets/images/masterrank_preview/preview-next.svg"></v-img>
                                            <v-img class="hidden-xs-only"
                                                   contain
                                                   src="@/assets/images/masterrank_preview/preview-next-xl.svg"></v-img>
                                        </v-col>
                                    </v-row>

                                    <div v-if="achievement.actual_rank.name === 'Member'"
                                         v-html="$options.filters.master($vuetify.lang.t('$vuetify.page_rang_detail.become_a_desc_b'))">
                                    </div>
                                    <div v-else
                                         v-html="$options.filters.master($vuetify.lang.t('$vuetify.page_rang_detail.become_a_desc'))">
                                    </div>
                                </div>

                                <v-tabs v-model="achievementDetails"
                                        class="achievements"
                                        :value="achievementDetails"
                                        :show-arrows="true"
                                        background-color="transparent">
                                    <v-tab v-for="achievementItem in achievement.achievements"
                                           :key="achievementItem.id"
                                           class="d-flex flex-column justify-center align-center px-1">
                                        <div v-if="achievementItem.completed"
                                             style="width: 70px; height: 70px;"
                                             class="d-flex align-center justify-center">
                                            <v-avatar size="60">
                                                <v-img :src="getMedalImage(achievementItem)"
                                                       aspect-ratio="1"
                                                       max-width="60px"></v-img>
                                            </v-avatar>
                                        </div>
                                        <v-progress-circular v-else
                                                             :rotate="90"
                                                             :size="70"
                                                             :width="5"
                                                             :value="calcProgress(achievementItem)"
                                                             color="primary">
                                            <v-avatar size="60">
                                                <v-img v-if="achievementItem && achievementItem.achievement && achievementItem.achievement.icon"
                                                       :src="achievementItem.achievement.icon"
                                                       :style="{ opacity: !achievementItem.completed ? .7 : 1 }"
                                                       aspect-ratio="1"
                                                       max-width="60px"></v-img>
                                            </v-avatar>
                                        </v-progress-circular>
                                        <div :class="{ 'tabs-masterpoints': achievementItem.completed }">
                                            <div class="body-1 text-center text-uppercase mt-2"
                                                 v-html="achievementItem.achievement.name[$vuetify.lang.current]
                                                        ? achievementItem.achievement.name[$vuetify.lang.current]
                                                        : achievementItem.achievement.name"></div>
                                            <div class="headline text-center font-weight-bold">
                                                {{ calcProgress(achievementItem) }}%
                                            </div>
                                        </div>
                                    </v-tab>
                                </v-tabs>

                                <v-tabs-items v-model="achievementDetails">
                                    <v-tab-item v-for="achievementItem in achievement.achievements"
                                                :key="`details${achievementItem.id}`"
                                                background-color="transparent">
                                        <v-row no-gutters>
                                            <v-col cols="12"
                                                   class="text-uppercase font-weight-bold pt-3">
                                                {{
                                                    $vuetify.lang.t('$vuetify.widgets.achievements.title',
                                                        achievementItem.achievement.name[$vuetify.lang.current]
                                                            ? achievementItem.achievement.name[$vuetify.lang.current]
                                                            : achievementItem.achievement.name)
                                                }}
                                            </v-col>
                                            <v-col cols="12">
                                                <div v-html="achievementItem.achievement.description[$vuetify.lang.current]
                                                        ? achievementItem.achievement.description[$vuetify.lang.current]
                                                        : achievementItem.achievement.description"></div>
                                                <v-btn text
                                                       color="primary"
                                                       class="ma-0 pa-0 mt-n2"
                                                       v-if="achievementItem.achievement.name === 'Newsreader'"
                                                       :to="newsLink">
                                                    {{ $vuetify.lang.t('$vuetify.widgets.achievements.link_to_news') }}
                                                </v-btn>
                                            </v-col>
                                            <v-col class="align-center pr-1 pt-4"
                                                   cols="auto">
                                                {{
                                                    achievementItem.achievement.label_progress[$vuetify.lang.current]
                                                        ? achievementItem.achievement.label_progress[$vuetify.lang.current]
                                                        : achievementItem.achievement.label_progress
                                                }}:
                                            </v-col>
                                            <v-col class="d-flex align-end error--text"
                                                   :class="{ 'success--text': achievementItem.completed }"
                                                   cols="auto">
                                                <div class="d-flex align-baseline">
                                                        <span class="headline font-weight-bold">
                                                            {{ achievementItem.progress }}/
                                                        </span>
                                                    <span>{{ achievementItem.target }}</span>
                                                </div>
                                            </v-col>
                                        </v-row>
                                    </v-tab-item>
                                </v-tabs-items>

                                <div class="mt-8"
                                     v-if="achievement.actual_rank.name !== 'Member'">
                                    <div class="mb-4"
                                         v-html="$options.filters.master($vuetify.lang.t('$vuetify.page_rang_detail.requirement_level_up'))"></div>
                                    <mp-multi-progress class="mb-2"
                                                       :percent="maximumMasterpoints"
                                                       :attribute-color-mapping="attributeColorMapping"
                                                       :items="achievement.masterpoints"></mp-multi-progress>

                                    <i18n path="$vuetify.page_rang_detail.actual"
                                          class="d-flex align-center mb-6">
                                        <div class="d-flex align-baseline mx-1 error--text"
                                             :class="{ 'success--text': achievement.masterpoints.sum_points >= maximumMasterpoints }">
                                            <span class="headline font-weight-bold">
                                                {{ achievement.masterpoints.sum_points }}/
                                            </span>
                                            <span>{{ maximumMasterpoints }}</span>
                                        </div>
                                    </i18n>

                                    <mp-progress v-for="(value, key) in achievement.masterpoints"
                                                 v-if="key !== 'sum_points'"
                                                 :key="key"
                                                 :name="key"
                                                 :user="currentUser"
                                                 :brand="brands[filterAchievementTab]"
                                                 :attribute-color-mapping="attributeColorMapping"
                                                 :value="value"
                                                 :ihk-certificate="achievement.ihk_certificate"
                                                 :max="50" />
                                </div>

                                <div class="mt-7"
                                     v-if="achievement && achievement.actual_rank && achievement.actual_rank.name === 'Member'">
                                    <div v-html="$vuetify.lang.t('$vuetify.page_rang_detail.headline')"
                                         v-if="$vuetify.lang.t('$vuetify.page_rang_detail.headline')"
                                         class="subtitle-1 font-weight-bold"></div>
                                    <div class="body-1 mb-7"
                                         v-html="$vuetify.lang.t('$vuetify.page_rang_detail.description')"
                                         v-if="$vuetify.lang.t('$vuetify.page_rang_detail.description')"></div>
                                    <v-btn block
                                           depressed
                                           color="primary darken-1"
                                           :to="buttonUrl"
                                           v-if="$vuetify.lang.t('$vuetify.page_rang_detail.button_text')">
                                        <span v-html="$options.filters.master($vuetify.lang.t('$vuetify.page_rang_detail.button_text'))"></span>
                                    </v-btn>
                                </div>
                                <div class="mt-7"
                                     v-else>
                                    <v-btn block
                                           depressed
                                           color="primary darken-1"
                                           :to="buttonUrl"
                                           v-if="$vuetify.lang.t('$vuetify.page_rang_detail.button_text')">
                                        <span v-html="$options.filters.master($vuetify.lang.t('$vuetify.page_rang_detail.button_text'))"></span>
                                    </v-btn>
                                </div>
                            </div>
                        </v-tab-item>
                    </v-tabs-items>
                </v-col>
            </v-row>
        </v-card>
    </div>
</template>

<script>
// components
import BackButton from '../components/BackButton';
import MpProgress from '../components/MpProgress';
import MpMultiProgress from '../components/MpMultiProgress';
// mixins
import achievementTab from '../mixins/achievementTab';
// models
import User from '../models/User';
// utils
import {
    medalImage,
    setPageTitle,
} from '../utils/helper';
import {
    ROUTE_NEWS,
    ROUTE_STATIC_PAGE,
} from '../utils/constants';

export default {
    name: 'rang',
    mixins: [
        achievementTab,
    ],
    props: {
        achievement: {
            default: null,
        },
    },
    components: {
        MpMultiProgress,
        MpProgress,
        BackButton,
    },
    data() {
        return {
            achievementDetails: undefined,
            requiredYear: 2022,
            currentYear: new Date().getFullYear(),
        };
    },
    methods: {
        getMedalImage(achievementItem) {
            const item = achievementItem.achievement.identifier ? achievementItem.achievement.identifier : achievementItem.achievement.name.toLowerCase();
            return medalImage(item, achievementItem.completed);
        },
        calcProgress(achievement) {
            const calc = achievement.progress / achievement.target * 100;
            return calc > 100 ? 100 : Math.round(calc);
        },
        handleTabUpdate(e) {
            this.achievementDetails = undefined;
            this.setFilter({
                item: 'filterAchievementTab',
                value: e,
            });
        },
    },
    computed: {
        currentUser() {
            return User.getCurrent();
        },
        maximumMasterpoints() {
            if (new Date().getFullYear() === 2021) {
                return 80;
            }
            return 100;
        },
        attributeColorMapping() {
            return {
                trade_fairs: '#be0443',
                trainings: '#0089bf',
                sold_vehicles: '#004a79',
                ihk_premium_seller: '#e5b900',
                google_rating: '#2fc156',
            };
        },
        brands() {
            return this.achievements.map((achievement, index) => {
                return {
                    id: index,
                    name: achievement.brand.name.toUpperCase(),
                };
            });
        },
        buttonUrl() {
            return {name: ROUTE_STATIC_PAGE, params: {slug: 'rank'}};
        },
        newsLink() {
            return {name: ROUTE_NEWS};
        },
    },
    mounted() {
        this.$nextTick(() => {
            if (this.achievement) {
                this.achievementDetails = this.achievement;
            }
        });
    },
};
</script>
